import TextField from '@material-ui/core/TextField'
import styled from 'styled-components'

const InputFieldStyled = styled(TextField)`
    width: 100%;
`

const InputField = ({ field, form, type, placeholder }) => {
    const {errors, touched} = form
    const {name} = field
    const isShowError = errors[name] && touched[name];

    
    return (
        <InputFieldStyled
            {...field}
            error={isShowError}

            type={type}
            label={placeholder}
            helperText={isShowError && errors[name]}
        />
    )
}

export default InputField
